import {InjectionToken} from '@angular/core';

export const MATOMO_SITE_ID = new InjectionToken<string>('MATOMO_SITE_ID');
